import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import ClientViewDragRegion from '../components/dragRegion';
import LoginMain from "./components/main";
import LoginFooter from "./components/footer";

async function checkUserSession() {
    const response = await fetch('/api/check-token', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        return true;
    } else {
        return false;
    }
}

function ClientViewLoginPage() {
    const navigate = useNavigate();
    const [isClient, setIsClient] = useState(false);

    const [showAlertOK, setShowAlertOK] = useState(false)
    const [OKAlertText, setOKAlertText] = useState("")

    const [showAlertERROR, setShowAlertERROR] = useState(false)
    const [ERRORAlertText, setERRORAlertText] = useState("")

    useEffect(() => {
        async function startClient () {
            if (await checkUserSession()) {navigate("/client-view")}
        }

        startClient()
    }, [navigate])

    const showAlert = (type, text) => {
        if (type === "error") {
            setShowAlertERROR(true)
            setERRORAlertText(text)

            setTimeout(function() {
                setShowAlertERROR(false)
            }, 3500)
        }
    }

    const handleLogin = async (dati) => {
        const response = await fetch('/api/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dati),
        });

        const data = await response.json();

        if (response.ok) {
            if (data.status === "1") {
                if (window.pywebview && window.pywebview.api) {
                    try {
                        await window.pywebview.api.save_token_from_web(data);

                        setShowAlertOK(true)
                        setOKAlertText("Logged as " + dati.email + ", redirecting")

                        setTimeout(function() {
                            navigate('/client-view');
                        }, 2500)
                    } catch (err) {
                        showAlert("error", err)
                    }
                }
            } else {
                navigate('/client-view/two-factor-auth?token=' + data.token)
            }
        } else {
            showAlert("error", data.detail.msg)
        }
    };

    useEffect(() => {
        if (window.pywebview && window.pywebview.api && window.pywebview.api.resize_window) {
            window.pywebview.api.resize_window(1200, 1000);
            setIsClient(true)
        }
    })

    if (!isClient) {
        return (
            <div className="relative flex justify-center items-center min-h-screen w-full flex-col overflow-x-hidden">
                <p>You can view this page only via client windows software</p>
            </div>
        )
    }

    return (
        <>
            <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden">
                <ClientViewDragRegion value={1}/>
                <LoginMain onLoginSubmit={handleLogin}/>
                <LoginFooter/>
            </div>

            {showAlertOK && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-green text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{OKAlertText}</span>}
            {showAlertERROR && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-red text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{ERRORAlertText}</span>}
        </>
    );
}


export default ClientViewLoginPage;